import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import React, { FunctionComponent } from "react";
import { useAddManufacturerImageMutation } from "../../redux/reducer/features/Product/productSlice";

interface IProps {
  isOpen: boolean;
  onClose: any;
  manufacturer: any;
  refetch: any;
}

const ManufacturerImageDialog: FunctionComponent<IProps> = ({
  isOpen,
  onClose,
  manufacturer,
  refetch,
}) => {
  const [imageFile, setImageFile] = React.useState<File>();
  const [manufacturerImage, manufacturerImageResult] =
    useAddManufacturerImageMutation();
  const handleUploadClick = (e: any) => {
    var file = e.target.files[0];
    console.log(file);
    setImageFile(file);
  };

  const handleOnSubmit = () => {
    if (imageFile) {
      const formData = new FormData();
      formData.append("formFile", imageFile);
      manufacturerImage({
        data: formData,
        manufacturerId: manufacturer.id,
      }).finally(() => {
        refetch();
        onClose();
      });
      //   productImageMutation({ data: formData });
    }
  };
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle alignSelf={"center"}> Manufacturer Image</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{}}
          validationSchema={{}}
          onSubmit={(values) => {
            handleOnSubmit();
          }}
          enableReinitialize={true}
        >
          {({
            values,
            errors,

            handleChange,
            handleBlur,
          }) => (
            <>
              <Form>
                <Grid
                  container
                  spacing={3}
                  justifyContent="space-between"
                  display="flex"
                  p={5}
                >
                  <Grid item xs={12} sm={12}>
                    <TextField
                      type="file"
                      id="imageFile"
                      name="imageFile"
                      label="Image"
                      fullWidth
                      autoComplete="family-name"
                      variant="standard"
                      onChange={handleUploadClick}
                      onBlur={handleBlur}
                      inputProps={{
                        accept: "image/*",
                      }}
                    />
                    <ErrorMessage
                      className="error-msg"
                      component={"div"}
                      name="File"
                    />
                  </Grid>
                  <Grid item xs={12} mt={3}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-end"
                    >
                      <Grid item>
                        <Button
                          color="error"
                          variant="contained"
                          onClick={() => {
                            onClose();
                          }}
                          disabled={manufacturerImageResult.isLoading}
                        >
                          Cancel
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          type="submit"
                          onClick={() => {
                            handleOnSubmit();
                          }}
                          disabled={manufacturerImageResult.isLoading}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            </>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default ManufacturerImageDialog;
